import React from 'react';
import { Logo } from '@icons';
import { ComponentInfo } from '@components';
import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';

export const LogoPlaceholder: React.FC = () => {
	return (
		<ComponentInfo name="LogoPlaceholder">
			<Box>
				<Logo />
			</Box>
		</ComponentInfo>
	);
};
